import { Component, Inject } from '@angular/core';
import { OKTA_CONFIG, OktaAuthStateService } from '@okta/okta-angular';
import type { OktaAuth } from '@okta/okta-auth-js';
import { Router } from '@angular/router';

// import Angular Material modules
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

// import services
import { UserService } from '../services/user-service';

@Component( {
  selector: 'app-login',
  imports: [
    MatButtonModule,
    MatProgressBarModule
  ],
  templateUrl: './login.html',
  styleUrl: './login.css'
} )
export class Login
{
  protected title = 'Community Health Record™';
  protected footer = 'Copyright © ' + new Date( Date.now() ).getFullYear() + ', Care Coordination Systems v7.2.1.0-main-420e2f6-20240719024814';
  public isAuthenticated = false;
  constructor(
    @Inject( OKTA_CONFIG ) private oktaConfig: { oktaAuth: OktaAuth },
    private _router: Router,
    private _oktaStateService: OktaAuthStateService, // Replace with actual Okta state service if available
    private _userService: UserService,
  )
  {
    this.checkAuthentication();
  }

  public async signIn(): Promise<void>
  {
    await this.oktaConfig.oktaAuth.signInWithRedirect();
  }

  private async checkAuthentication(): Promise<void>
  {
    this._oktaStateService.authState$.subscribe( ( state: any ) =>
    {
      const isAuthenticated = state.isAuthenticated ?? false;
      if ( isAuthenticated )
      {
        this.isAuthenticated = true;
        this._userService.completeLogin()
          .then( () => this._router.navigate( ['main'] ) )
          .catch( ( error ) => console.error( 'Error completing login:', error ) );
      } else
      {
        this.isAuthenticated = false;
      }
    } );
  }

}
